export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-base">
                努
              </span>
              <span className="text-lg font-heading font-bold text-background-50">努努影院</span>
            </div>
            <p className="text-xs text-background-300 leading-relaxed mb-4">
              努努影院提供<strong className="text-background-100">免费高清电视剧全集在线观看</strong>，最新剧集实时更新，播放不缓冲。无论国产剧、韩剧、美剧还是动漫番剧，流畅追剧从努努开始。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">热播排行</a>
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a>
              <a href="#carousel" onClick={(e) => handleNavClick(e, '#carousel')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">精选专题</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">剧集分类</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">热门题材</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">悬疑烧脑</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">古装仙侠</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">韩剧精选</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">动漫番剧</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-xs text-background-300 hover:text-primary-400 transition-colors cursor-pointer">美剧精选</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-400 leading-relaxed">
              合作伙伴信息待更新，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 努努影院 · 免费高清电视剧全集在线观看 · 流畅追剧首选
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</a>
            <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">帮助</a>
            <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}